export interface ShipmentDetailMagento {
  id: string;
  orderNo: number;
  customer: string;
  deliveryAddress: string;
  sellingCompany: string;
  despatchNoteNumber: string;
  customerOrderNo: string;
  customerOrderRef: string;
  orderLine: number;
  shipper: string;
  trackingNumber: string;
  product: string;
  productDescription: string;
  orderQuantity: number;
  deliveredQuantity: number;
  dateEntered: Date;
  dateDelivered: Date;
}
